<template>
  <div class="chatList-box">
    <el-divider></el-divider>
    <el-button class="newChat-btn" type="primary" icon="el-icon-plus" plain round @click="newChat">开启新对话</el-button>
    <div class="history-title"><i class="el-icon-time" style="margin-right: 5px;" />历史对话</div>
    <div class="history-list">
      <vue-scroll  :ops="scrollOptions" ref="scrollbarRef"  @handle-scroll="handleScroll" >
        <div class="history-item" :class="{selected:sessionId==item.id,show:item.isShow}" v-for="item in historyList">
          <div class="title" @click="loadChatList(item)"> {{ item.title }}</div>
          <!-- <div class="btn" @click.stop="deleteChart(item)"><div class="btn-del"><i class="el-icon-delete" /></div></div> -->
          <el-dropdown trigger="click" @visible-change="handleShow($event,item)" @command="handleOpt($event,item)">
            <div class="btn" >
              <div class="btn-del"><i class="el-icon-more" /></div>
            </div>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item icon="el-icon-edit" command="edit">重命名</el-dropdown-item>
              <el-dropdown-item icon="el-icon-delete" command="del">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
      </vue-scroll>
     
    </div>

    <el-dialog  title="重命名" append-to-body :close-on-click-modal="false" :visible.sync="visible"  width="500px" >
      <el-form ref="form" :model="form" :rules="rules"  label-width="0px">
        <el-form-item label="" prop="title">
          <el-input placeholder="" v-model="form.title"  :clearable="true" v-on:keyup.13.native="formSubmit" />      
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="visible=false">取 消</el-button>
        <el-button :loading="btnLoading" type="primary" @click="formSubmit">保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { sessions,sessionsDel,sessionsEdit } from '@/apis/oms/AI-chat'
import { mapState } from 'vuex'
export default {
  computed: {
    disabled () {
      return this.loading || this.noMore
    },
    ...mapState({
      //sessionId: state=>state.chat.sessionId,
      changeSessionIdMethod: state=>state.chat.changeSessionIdMethod,
      isChange: state=>state.chat.isChange,
      newSessionMethod: state => state.chat.newSessionMethod,
      modelType:state => state.chat.modelType,
    })
  },
  watch: {
    '$route'() { 
      this.sessionId = this.$route.params.id || null;
      //console.log(this.sessionId)
    }
  },
  data() {
    return {
      sessionId:null,
      page: {
        current: 1,
        pageSize: 20,
        total:0
      },
      historyList: [],
      loading: false,
      noMore: false,

      // 滚动条配置
      scrollOptions: {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
          background: '#c1c1c1',
          size: '6px'
        }
      },

      form: {
        title: null,
      },
      rules: {
        title: [{ required: true, message: '请输入会话标题', trigger: 'blur' }],
      },
      visible:false,
      btnLoading: false,
      curRow:null,
    }
  },
  created() { 
     this.sessionId = this.$route.params.id || null;
    //设置刷新会话列表事件
    this.$store.dispatch('update_refreshSessionListMethod', this.getList).then(res => { 
      //this.getList(true)
    })
   
  },
  methods: {
    getList(b) { 
      if (b) {
        this.page.current = 1;
        this.historyList = [];
        this.loading = false;
        this.noMore = false;
      } else { 
        this.page.current++;
      }
      this.loading = true;
      sessions({
        ...this.page,
        modelMode:this.modelType
      }).then(data => { 
       
        this.historyList = this.historyList.concat(data.rows|| [])
        if (this.page.pageSize * this.page.current >= data.total) {
          this.noMore = true;
        }
          
       
        this.loading = false;
      }).catch(err => { 
        this.loading = false;
        this.noMore = true;
      })
    },
    newChat() { 
      //增加会话
      // this.$store.dispatch('update_sessionId', null).then(res => {
      //   this.newSessionMethod();
      // })
  
      if (this.$route.name.indexOf('-id') > -1) {
        this.$router.push({ name: this.$route.name.replace('-id', '') });
      } else { 
        this.$router.push({ name: this.$route.name });
      }
      //this.newSessionMethod();
    },
    loadChatList(item) { 
      //切换会话
      // console.log(this.$route.path)
      if (this.$route.name.indexOf('-id') > -1) {
        this.$router.push({ name: this.$route.name, params: { id: item.id } });
      } else { 
        this.$router.push({ name: this.$route.name+'-id', params: { id: item.id } });
      }
      
      // this.$store.dispatch('update_sessionId', item.id).then(res => { 
      //   this.changeSessionIdMethod(item.id)
      // })
    },
    handleScroll(vertical, horizontal, nativeEvent) { 
      if (this.disabled) return;
     
      if (!this.$refs.scrollbarRef) return

      const { clientHeight, scrollHeight, scrollTop } = nativeEvent.target
      // 判断是否滚动到底部（预留 5px 的误差容忍度，避免精度问题）[citation:8]
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.getList(false)
      }
    },
    deleteChart(item) {
      this.$confirm('确定要删除该对话吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionsDel(item.id).then(data=>{
          this.getList(true);
          this.newChat();
        }).catch(err=>{
        })
      }).catch(()=>{})
    },

    handleShow(b, item) { 
      if (b) {
        this.$set(item, 'isShow', true)
      } else { 
        this.$set(item, 'isShow', false)
      }
    },

    toEditTitle(item) { 
      this.form.title = item.title
      this.btnLoading = false;
      this.curRow = item;
      this.visible = true;
    },
    formSubmit() { 
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          sessionsEdit(this.curRow.id, this.form.title).then(res => { 
            this.curRow.title = this.form.title;
            this.visible = false;
            this.btnLoading = false;
          }).catch(err => { 
            this.btnLoading = false;
          })
        }
      })
    },

    handleOpt(cmd, item) { 
      switch (cmd) { 
        case 'edit':
          this.toEditTitle(item)
          break;
        case 'del':
          this.deleteChart(item)
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 .chatList-box{
    flex:1;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    //max-width: 260px;
  
    ::v-deep .__view{
      max-width: 260px !important;
    }
    .el-divider--horizontal{
      margin: 10px 0;
      margin-top: 0;
    }
    .newChat-btn{
      width:220px;
      text-align: center;
      flex: 0 0 auto;
      margin: 0 auto;
    }
    .history-title{
      color: #00000059;
      font-size: 12px;
      padding-left: 20px;
      padding-top: 20px;
    }
    .history-list{
      flex:1;
      overflow: hidden;
      .history-item{
        font-size: 14px;
        padding: 3px 20px;
        margin: 5px 10px;
        display: flex;
        align-items: center;
        line-height: 30px;
        color:#888C91;
        border-radius: 20px;
        cursor: pointer;
        .title{
          flex:1;
          width:100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .btn{
          display: none;
          justify-content: center;
          
          .btn-del{
            flex:0 0 auto;
            cursor: pointer;
            padding:0 3px;
            height:26px;
            color:#333;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding:0 5px;
            border-radius: 10px;
          }
          .btn-del:hover{
            background: #e1e1e1;
          }
        }
        
      }
      .selected{
        background: #fff !important;
        .btn{
          display: flex;
        }
      }
      .history-item:hover{
        background: #E5E7EA;
        //border-radius: 20px;
        color:#4F5153;
        .btn{
          display: flex;
        }
      }
      .show{
        background: #E5E7EA;
        .btn{
          display: block;
          .btn-del{
            background: #e1e1e1;
          }
        }
       
      }
      p{
        color: #00000059;
        font-size: 12px;
        text-align: center;
      }
    }
  }
</style>